import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };
  static targets = ["status", "rustdeskLink"];

  async open(event) {
    event.preventDefault();

    this.setStatus(this.loadingText());

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });

      if (!response.ok) {
        this.setStatus(this.errorText());
        return;
      }

      const data = await response.json();
      const password = data.password;
      if (!password) {
        this.setStatus(this.errorText());
        return;
      }
      this.updateRustdeskLink(password);
      this.setStatus("");
      window.location.href = this.rustdeskLinkTarget.getAttribute("href");
    } catch (error) {
      this.setStatus(this.errorText());
    }
  }

  setStatus(text) {
    this.statusTarget.textContent = text;
  }

  loadingText() {
    return this.element.dataset.zabbixRustdeskLoadingText;
  }

  errorText() {
    return this.element.dataset.zabbixRustdeskErrorText;
  }

  updateRustdeskLink(password) {
    const href = this.rustdeskLinkTarget.getAttribute("href") || "";
    const base = href.split("?")[0];
    const encoded = encodeURIComponent(password);
    const updated = `${base}?password=${encoded}`;
    this.rustdeskLinkTarget.setAttribute("href", updated);
  }
}
